/**
 * A coarse "browser · OS" label for the session list (ASVS 3.3.4), derived once from the User-Agent at
 * sign-in. The raw User-Agent is never stored: the label is enough for a person to recognise "my phone"
 * and too coarse to fingerprint anyone.
 */
export function clientLabel(userAgent: string | null | undefined): string | null {
  if (!userAgent) return null;
  const ua = userAgent.slice(0, 512);
  const browser =
    /\bEdg(?:e|A|iOS)?\//.test(ua) ? 'Edge'
    : /\bSamsungBrowser\//.test(ua) ? 'Samsung Internet'
    : /\bOPR\/|\bOpera\b/.test(ua) ? 'Opera'
    : /\bFirefox\/|\bFxiOS\//.test(ua) ? 'Firefox'
    : /\bCriOS\/|\b(?:Headless)?Chrome\//.test(ua) ? 'Chrome'
    : /\bSafari\//.test(ua) ? 'Safari'
    : null;
  const os =
    /\biPad\b/.test(ua) ? 'iPadOS'
    : /\biPhone\b|\biPod\b/.test(ua) ? 'iOS'
    : /\bAndroid\b/.test(ua) ? 'Android'
    : /\bCrOS\b/.test(ua) ? 'ChromeOS'
    : /\bWindows\b/.test(ua) ? 'Windows'
    : /\bMac OS X\b|\bMacintosh\b/.test(ua) ? 'macOS'
    : /\bLinux\b/.test(ua) ? 'Linux'
    : null;
  if (browser === null && os === null) return null;
  return os === null ? browser : `${browser ?? 'Browser'} · ${os}`;
}
